import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-28 sm:pt-32 pb-20">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm font-semibold text-navy/70 hover:text-navy transition-colors"
          >
            <ArrowLeft size={16} /> Torna alla home
          </Link>
          <h1 className="mt-5 font-display font-extrabold tracking-tight text-navy text-4xl sm:text-5xl">
            {title}
          </h1>
          {updated && <p className="mt-3 text-sm text-ink/50">Ultimo aggiornamento: {updated}</p>}
          <div className="mt-8 text-ink/75 text-[15px] leading-relaxed space-y-5">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export function LegalH2({ children }) {
  return <h2 className="font-display font-bold text-navy text-xl mt-10 mb-3">{children}</h2>;
}
